@for (item of sidebars; track $index) {
<div class="flex flex-justify-between flex-middle p-t-2 p-t-3-m p-t-3-s p-b-2 p-b-3-m p-b-3-s b-t b-col-5 cursor-pointer _item"
     tabindex="0"
     role="button"
     (click)="productViewLayout().openSidebar(item.sidebar)"
     (keypress)="productViewLayout().openSidebar(item.sidebar)">
    <p class="m-l-4-m m-l-4-s s1">{{item.title}}</p>
    <i class="m-r-1 m-r-3-m m-r-3-s icon-plus-24"
       aria-hidden="true"></i>
</div>
@if (client.isPrerender) {
@switch (item.sidebar) {
@case ('details') {
<product-layout-details-sections class="ng-hide"
                                 [productViewLayout]="productViewLayout()"
                                 [content]="content()" />
}
@case ('delivery') {
<product-layout-delivery-price class="ng-hide"
                               [productId]="product().id"
                               [content]="content()" />
}
}
}
}
<!-- reviews -->
<product-layout-reviews [product]="product()"
                        [productViewLayout]="productViewLayout()"
                        [top]="false" />
<!-- gift boxing -->
@if (productViewLayout().parent?.data?.allow_gift_box && isGiftBoxesEnabled) {
<div class="flex flex-justify-between flex-middle p-t-2 p-t-3-m p-t-3-s p-r-2 p-r-4-s p-b-2 p-b-3-m p-b-3-s p-l-2 p-l-4-s b-t b-col-5 bg-col-5 cursor-pointer _item"
     tabindex="0"
     role="button"
     (click)="productViewLayout().openSidebar('gift-boxing')"
     (keypress)="productViewLayout().openSidebar('gift-boxing')">
    <p class="flex flex-middle gap s1">
        <i class="icon-gift-24"
           aria-hidden="true"></i>
        {{'A gift? Build a personalised box' | translate}}
    </p>
    <span class="link underline">{{'Learn more' | translate}}</span>
</div>
@if (client.isPrerender) {
<product-layout-gift-boxing class="ng-hide"
                            [content]="content()" />
}
}